import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate } from 'react-router-dom';
import { strings } from '../../resources/strings/strings';
import { ReactComponent as Logo } from '../../resources/waspLogo.svg';
import './Footer.scss';

export const Footer = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:768px)');

  return (
    <Box component='footer' className='footer'>
      <Container maxWidth='xl'>
        <Stack
          spacing={isMobile ? 0 : 12}
          direction={isMobile ? 'column' : 'row'}
          justifyContent='space-evenly'
          className='footer-container'
        >
          <div className='footer-logo'>
            <Stack
              direction={isMobile ? 'row' : 'column'}
              justifyContent={isMobile ? 'space-between' : 'flex-start'}
              alignItems={isMobile ? 'center' : 'flex-start'}
              sx={{ width: '100%' }}
            >
              <div className='logo-wrapper-footer' style={{ minWidth: '120px' }}>
                <Logo />
              </div>
              {!isMobile && <Typography variant='subtitle1'>{strings.res_footerLogoText}</Typography>}
              <Stack direction='row' spacing={1} sx={{ mt: isMobile ? '-8px' : 2 }}>
                <IconButton
                  aria-label='Facebook'
                  color='primary'
                  href='https://www.facebook.com/profile.php?id=61574915312741&locale=hr_HR'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FacebookIcon sx={{ fontSize: 32 }} />
                </IconButton>
                <IconButton
                  aria-label='Instagram'
                  color='primary'
                  href='https://www.instagram.com/wasp.hr/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <InstagramIcon sx={{ fontSize: 32 }} />
                </IconButton>
              </Stack>
            </Stack>
            {isMobile && (
              <Typography variant='subtitle1' sx={{ mt: 2 }}>
                {strings.res_footerLogoText}
              </Typography>
            )}
          </div>
          <div className='footer-navigation'>
            <Stack direction='row' justifyContent='space-between' textAlign='left'>
              <Button className='footer-button' variant='text' onClick={() => navigate('/contact')}>
                {strings.res_contact}
              </Button>
              <Button className='footer-button' variant='text' onClick={() => navigate('/terms-and-conditions')}>
                {strings.res_termsOfUse}
              </Button>
              <Button className='footer-button' variant='text' onClick={() => navigate('/privacy-statement')}>
                {strings.res_privacyStatement}
              </Button>
              <Button className='footer-button' variant='text' onClick={() => navigate('/partners')}>
                {strings.res_forPartners}
              </Button>
            </Stack>
          </div>
        </Stack>
      </Container>
    </Box>
  );
};
